import defaultHttpClient from 'hub-http/clients/apiClient';
/**
 * Fetches the session info for the given `sessionId`.
 * This is used to check the status of the authentication flow.
 *
 * @param httpClient - Optional HTTP client override. Defaults to
 *   `hub-http/clients/apiClient` (portal-session auth). Pass a custom client
 *   for non-portal contexts (e.g. Janus IDP stacks).
 */
export function fetchSessionInfo(portalId, sessionId, httpClient = defaultHttpClient) {
  return httpClient.get(`/api/unified-auth/v1/authenticators/session/${sessionId}`, {
    query: {
      portalId
    }
  }).then(response => Object.assign({}, response, {
    params: new Map(Object.entries(response.params || {}))
  }));
}